import { CustomerSchema } from "@redotech/redo-model/customer";
import * as z from "zod";

export const getCustomerById = {
  name: "getCustomerById" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ customer: CustomerSchema.optional() }),
};
